module.exports = __webpack_public_path__ + "static/media/arrowhand.99eb5263.svg";